import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { MiniCta } from '../CtaBlock';
import { gains, painPoints } from '../../data/content';
export function BeforeAfter() {
  return <section className="bg-ink-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-76" data-mp="26m349yktrxkh">
      <div className="mx-auto max-w-5xl" data-id="element-77" data-mp="26k9xmja7pdch">
        <h2 className="text-center font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-5xl" data-id="element-78" data-mp="22lat2zse7ilk">
          Smetti di avere dubbi ogni volta che accendi la tua saldatrice
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-79" data-mp="2ubf96m94djgz">
          <div className="rounded-2xl border border-red-900/50 bg-red-950/20 p-5 sm:p-6" data-id="element-80" data-mp="2u9ukhd9hkur1">
            <p className="font-display text-xl font-bold uppercase tracking-wide text-red-400 sm:text-2xl" data-id="element-81" data-mp="2qcga3ia2kgxg">
              Oggi…
            </p>
            <ul className="mt-4 space-y-3.5" data-id="element-82" data-mp="1evq15re9hb05">
              {painPoints.map(item => <li key={item} className="flex gap-3" data-id="element-83" data-mp="19wdg9c6yae07">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" aria-hidden="true" data-id="element-84" data-mp="19usjdfx5yiz6" />
                  <span className="text-[15px] leading-snug text-bone/85" data-id="element-85" data-mp="1c4yxm6x7bjp8">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-arc/50 bg-arc/10 p-5 sm:p-6" data-id="element-86" data-mp="y6s9hii20y2r">
            <p className="font-display text-xl font-bold uppercase tracking-wide text-arc-light sm:text-2xl" data-id="element-87" data-mp="1327owevpn21a">
              Con il Sistema Maestro…
            </p>
            <ul className="mt-4 space-y-3.5" data-id="element-88" data-mp="t5ush98s6a2u">
              {gains.map(item => <li key={item} className="flex gap-3" data-id="element-89" data-mp="feq2kyv7sw5p">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-arc-light" aria-hidden="true" data-id="element-90" data-mp="fg12gnljhjrj" />
                  <span className="text-[15px] font-medium leading-snug text-bone" data-id="element-91" data-mp="5fqtxgag90ip">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-center font-display text-2xl font-bold uppercase text-bone sm:text-3xl" data-id="element-92" data-mp="2c40wqt05js76">
          Smetti di improvvisare. Inizia a saldare con un sistema.
        </p>

        <MiniCta label="Voglio saldare con un sistema" data-id="element-93" data-mp="23byxgy1tkhyh" />
      </div>
    </section>;
}